<template>
  <div class="honor-page">
    <section class="page-hero">
      <img src="/img/r6.jpg" alt="江苏道鼎升资质荣誉与认证展示" />
      <div class="page-hero-mask"></div>
      <div class="page-hero-content">
        <nav class="breadcrumb" aria-label="面包屑">
          <router-link to="/">首页</router-link>
          <span>/</span>
          <span>资质荣誉</span>
        </nav>
        <p class="eyebrow">Qualification</p>
        <h1>资质荣誉与信任基础</h1>
        <p>
          资质荣誉信息用于帮助客户理解江苏道鼎升在房屋查验、工程质量检测、服务流程和报告输出方面的基础能力。证书编号等详细信息未在页面公开展示，本站不做虚构。
        </p>
      </div>
    </section>

    <section class="section">
      <div class="section-inner">
        <div class="section-heading">
          <p class="eyebrow">Trust Items</p>
          <h2>可公开展示的信任信息</h2>
          <p>以下内容与页面可见业务信息保持一致，强调第三方服务经验、专业检测人员、标准化报告和长三角项目服务经验。</p>
        </div>
        <div class="trust-grid">
          <div class="trust-card" v-for="item in trustItems" :key="item">
            <i class="el-icon-medal"></i>
            <span>{{ item }}</span>
          </div>
        </div>
      </div>
    </section>

    <section class="section muted">
      <div class="section-inner">
        <div class="section-heading">
          <p class="eyebrow">Certificates</p>
          <h2>资质证书图片</h2>
          <p>以下图片来自当前项目已有素材。建议后续补充证书名称、有效期、编号和高清扫描件，由人工确认后再公开展示。</p>
        </div>
        <div class="honor-grid">
          <figure v-for="item in honorImages" :key="item.src">
            <img :src="item.src" :alt="item.alt" />
            <figcaption>{{ item.name }}</figcaption>
          </figure>
        </div>
      </div>
    </section>

    <section class="section cta-section">
      <div class="section-inner cta-inner">
        <div>
          <h2>需要了解资质与项目服务能力？</h2>
          <p>可在项目咨询时提出资质、报告样例、案例资料等需求，我们会基于可公开资料沟通。</p>
        </div>
        <router-link class="btn" :to="{ path: '/', hash: '#lead-form' }">咨询项目方案</router-link>
      </div>
    </section>
  </div>
</template>

<script>
import { trustItems } from "../data/services";
import {
  absoluteUrl,
  breadcrumbSchema,
  localBusinessSchema,
  organizationSchema,
  setSeo,
  setStructuredData
} from "../utils/seo";

export default {
  name: "Honor",
  data() {
    return {
      trustItems: trustItems,
      honorImages: [
        { src: "/img/r6.jpg", name: "资质证书展示", alt: "江苏道鼎升资质证书展示图片" },
        { src: "/img/r7.jpg", name: "资质证书展示", alt: "江苏道鼎升工程检测资质证书图片" },
        { src: "/img/r8.jpg", name: "资质证书展示", alt: "江苏道鼎升房屋查验资质证书图片" },
        { src: "/img/r4.jpg", name: "资质证书展示", alt: "江苏道鼎升质量管理相关证书图片" },
        { src: "/img/r5.jpg", name: "资质证书展示", alt: "江苏道鼎升检测服务资质证书图片" },
        { src: "/img/r3.jpg", name: "资质证书展示", alt: "江苏道鼎升项目服务资质证书图片" },
        { src: "/img/r2.png", name: "资质证书展示", alt: "江苏道鼎升荣誉资质图片" },
        { src: "/img/r1.png", name: "资质证书展示", alt: "江苏道鼎升认证证书图片" }
      ]
    };
  },
  mounted() {
    setSeo({
      title: "资质荣誉与报告样张｜江苏道鼎升工程检测",
      description:
        "江苏道鼎升工程检测有限公司资质荣誉页面展示可公开信任信息、资质资料展示区和报告样张补充说明，后续建议由人工核对证书编号、有效期和真实报告样例。",
      path: "/honor",
      image: "/img/r6.jpg"
    });
    setStructuredData([
      organizationSchema(),
      localBusinessSchema(),
      {
        "@type": "CollectionPage",
        name: "资质荣誉",
        url: absoluteUrl("/honor"),
        description: "江苏道鼎升工程检测有限公司资质荣誉与信任信息展示。"
      },
      breadcrumbSchema([
        { name: "首页", path: "/" },
        { name: "资质荣誉", path: "/honor" }
      ])
    ]);
  }
};
</script>

<style lang="scss" scoped>
.honor-page {
  background: #f5f8f7;
  color: #1f2d3d;
}

.page-hero {
  min-height: 430px;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.page-hero img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.page-hero-mask {
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, rgba(12, 38, 51, 0.95), rgba(15, 76, 92, 0.72));
}

.page-hero-content,
.section-inner {
  width: min(1180px, calc(100% - 48px));
  margin: 0 auto;
}

.page-hero-content {
  position: relative;
  z-index: 1;
  color: #fff;
}

.breadcrumb {
  display: flex;
  gap: 8px;
  margin-bottom: 26px;
  color: rgba(255, 255, 255, 0.78);
}

.breadcrumb a {
  color: rgba(255, 255, 255, 0.92);
  text-decoration: none;
}

.eyebrow {
  color: #d76b30;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 12px;
}

.page-hero h1 {
  font-size: 42px;
  line-height: 1.25;
  margin: 0 0 18px;
}

.page-hero p {
  max-width: 900px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 17px;
  line-height: 1.9;
}

.section {
  padding: 72px 0;
}

.muted {
  background: #fff;
}

.section-heading {
  max-width: 780px;
  margin-bottom: 30px;
}

h2 {
  color: #0f4c5c;
  font-size: 31px;
  line-height: 1.35;
  margin: 0 0 14px;
}

.section-heading p,
.cta-section p {
  color: #5c6873;
  line-height: 1.8;
}

.trust-grid,
.honor-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.trust-card,
.honor-grid figure {
  border: 1px solid #dce6e4;
  border-radius: 8px;
  background: #fff;
}

.trust-card {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 18px;
  color: #17313b;
}

.trust-card i {
  color: #d76b30;
  font-size: 24px;
}

.honor-grid figure {
  margin: 0;
  overflow: hidden;
}

.honor-grid img {
  width: 100%;
  height: 260px;
  display: block;
  object-fit: cover;
}

.honor-grid figcaption {
  color: #5c6873;
  padding: 12px;
  text-align: center;
}

.cta-section {
  background: #0f4c5c;
}

.cta-inner {
  display: flex;
  justify-content: space-between;
  gap: 24px;
  align-items: center;
}

.cta-inner h2,
.cta-inner p {
  color: #fff;
}

.btn {
  display: inline-flex;
  min-height: 44px;
  align-items: center;
  justify-content: center;
  padding: 0 22px;
  border-radius: 4px;
  background: #d76b30;
  color: #fff;
  text-decoration: none;
  white-space: nowrap;
}

@media (max-width: 980px) {
  .trust-grid,
  .honor-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .cta-inner {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 640px) {
  .page-hero-content,
  .section-inner {
    width: min(100% - 28px, 1180px);
  }

  .page-hero {
    min-height: auto;
    padding: 70px 0;
  }

  .page-hero h1 {
    font-size: 28px;
  }

  .section {
    padding: 52px 0;
  }

  .trust-grid,
  .honor-grid {
    grid-template-columns: 1fr;
  }
}
</style>
